function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0005 13.0684C13.2448 13.0684 16.2367 14.5167 18.1478 16.928C18.4548 17.3153 18.3722 17.8651 17.9634 18.156C17.5546 18.4468 16.9743 18.3686 16.6673 17.9813C15.1023 16.0067 12.6562 14.8225 10.0005 14.8225C7.3443 14.8225 4.89764 16.0072 3.33272 17.9826C3.02582 18.37 2.44556 18.4483 2.03668 18.1575C1.6278 17.8668 1.54513 17.317 1.85203 16.9296C3.76298 14.5174 6.75552 13.0684 10.0005 13.0684Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0003 1.6665C6.93286 1.6665 4.44617 4.02255 4.44617 6.92889C4.44617 9.83522 6.93286 12.1913 10.0003 12.1913C13.0678 12.1913 15.5545 9.83522 15.5545 6.92889C15.5545 4.02255 13.0678 1.6665 10.0003 1.6665ZM10.0004 3.42063C12.0453 3.42063 13.7031 4.99133 13.7031 6.92888C13.7031 8.86644 12.0453 10.4371 10.0004 10.4371C7.95536 10.4371 6.29757 8.86644 6.29757 6.92888C6.29757 4.99133 7.95536 3.42063 10.0004 3.42063Z",
  fill: "currentColor"
});

function SvgPassenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.94233c80.svg";
export { ForwardRef as ReactComponent };